import * as React from "react";
import { Outlet } from "react-router-dom";
import TermsOfUse from "./fragments/TermsOfUse";

const AuthLayout = () => {
  // TODO: Revisit this
  const isFullScreen = window.location.href.includes("add-personal-info");

  const LeadingVideo = () => (
    <video autoPlay muted loop className="h-full object-cover w-full">
      <source src="/videos/cropped2.mp4" type="video/mp4" />
    </video>
  );

  // Original Layout (for screens above 1200px)
  const OriginalLayout = () => (
    <div className="sm:flex w-full min-h-screen text-dark_night_sky font-sofia_pro">
      <div className="flex flex-col justify-center items-center w-[calc(100vw-555px)]">
        <div
          className={
            isFullScreen
              ? "min-h-screen h-full py-[100px]"
              : "flex flex-col justify-center items-center h-full"
          }
        >
          <div className="py-[40px]">
            <div className="h-[100px] w-full justify-center items-center">
              <a href="https://www.fohr.co/">
                <img
                  src="/images/fohr-logo-navy.png"
                  className="w-[80px] mx-auto"
                />
              </a>
            </div>
            <div className="w-full sm:w-[440px] m-auto inline-block p-2 sm:p-0">
              <Outlet />
            </div>
            <TermsOfUse />
          </div>
        </div>
      </div>
      <div className="fixed top-0 right-0 w-[555px] h-full">
        <LeadingVideo />
      </div>
    </div>
  );

  // New Layout (for screens 1200px and below)
  const NewLayout = () => (
    <div className="relative w-full min-h-screen text-white font-sofia_pro overflow-hidden">
      {/* Full screen background video */}
      <div className="absolute inset-0 z-0">
        <LeadingVideo />
      </div>

      {/* Content container with centered form */}
      <div className="relative z-10 flex min-h-screen h-full flex-col items-center justify-center w-full">
        <div className="flex flex-col items-center py-[40px] max-w-screen-xl w-full px-4">
          <div className="flex h-[100px] mb-8 justify-center items-center">
            <a href="https://www.fohr.co/">
              <img
                src="/images/fohr-logo-navy.png"
                className="w-[80px] brightness-0 invert"
                alt="Fohr"
              />
            </a>
          </div>

          {/* Login form with blurred white background */}
          <div
            className={`w-full sm:w-[440px] p-7 rounded-xl ${isFullScreen ? "py-[100px]" : ""}
                        bg-white/80 backdrop-blur-md shadow-lg text-dark_night_sky`}
          >
            <Outlet />
          </div>
          <TermsOfUse />
        </div>
      </div>
    </div>
  );

  // Render the appropriate layout based on screen width
  return (
    <>
      {/* Hide for large screens (above 1200px) */}
      <div className="hidden xl:block">
        <OriginalLayout />
      </div>

      {/* Show for small and medium screens (1200px and below) */}
      <div className="block xl:hidden">
        <NewLayout />
      </div>
    </>
  );
};

export default AuthLayout;
